export const MockCreatinineData = {
  date: "20191009T214241+0000",
  updateDate: "20191021T151736+0000",
  updatedBy: "Nurse Dev",
  creatinineClearanceDate: {
    date: "20191017",
  },
  addedBy: "Nurse Dev",
  serumCreatinine: null,
  id: "afa5bf57-9550-4665-9ccd-74e899a9b376",
  serumCreatinineDate: null,
  updatedById: 741346,
  creatinineClearance: null,
  addedById: 741346,
  createDate: "20191009T214241+0000",
};



// WEBPACK FOOTER //
// ./src/mocks/mock-creatinine.ts